module.exports = __webpack_public_path__ + "static/image3-fad741f2d0c465e19177820a12288a8f.jpg";